<template>
  <div class="page_activities">
    <h1>{{ "activities" | cz }}</h1>
    <div class="actions">
      <button class="add" @click="add" title="Přidat doprovodný program">
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div v-if="selectedActivity != null" class="selected">
      <label for="activity_name">Název</label>
      <inputer id="activity_name" :paths="['freeTimeActivities', selectedId, 'name']" :disabled="!is_new()" />
      <label for="activity_description">Popis</label>
      <inputer id="activity_description" :paths="['freeTimeActivities', selectedId, 'description']" lineCount="5" />
      <label for="activity_scope">Rozsah (alespoň 3 bloky)</label>
      <dropdownCheckInputer id="activity_scope" :paths="['freeTimeActivities', selectedId, 'scope']" :items="scope_items">
        <template v-slot:label="props">{{ props.items | activity_scopes }}</template>
        <template v-slot:item="props">{{ props.item | activity_scope }}</template>
      </dropdownCheckInputer>
      <label for="activity_place">Umístění programu <br />(např. louka, les za jídelnou apod.)</label>
      <inputer id="activity_place" :paths="['freeTimeActivities', selectedId, 'place']" />
      <label for="activity_grantAmount">Žádám o grant? (částka / prázdné)</label>
      <inputerNumber id="activity_grantAmount" :paths="['freeTimeActivities', selectedId, 'grantAmount']" />
      <label for="activity_grantUsage">Na co bude grant využit, <br/> jaké náklady chcete proplatit?</label>
      <inputer id="activity_grantUsage" :paths="['freeTimeActivities', selectedId, 'grantUsage']" lineCount="3" />
      <label for="activity_responsiblePersonName">Zodpovědná osoba</label>
      <inputer id="activity_responsiblePersonName" :paths="['freeTimeActivities', selectedId, 'responsiblePersonName']" />
      <label for="activity_responsiblePersonPhone">Telefon na zodpovědnou osobu</label>
      <inputer id="activity_responsiblePersonPhone" :paths="['freeTimeActivities', selectedId, 'responsiblePersonPhone']" />
      <label for="activity_responsiblePersonEmail">E-mail na zodpovědnou osobu</label>
      <inputer id="activity_responsiblePersonEmail" :paths="['freeTimeActivities', selectedId, 'responsiblePersonEmail']" />
      <label for="activity_note">Poznámka</label>
      <inputer id="activity_note" :paths="['freeTimeActivities', selectedId, 'note']" lineCount="3" />
      <button @click="select(null)">Zavřít</button>
    </div>
    <tabloid name="activities" :columns="columns" :data="activities">
      <template v-slot:outpostId="{ value }">{{ value }}. PH</template>
      <template v-slot:actions="{ row }">
        <button v-if="is_new(row.id)" class="remove" @click="remove(row.id)" title="Odebrat program">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>
  
<script>
import { mapState } from "vuex";
import { data } from "../store_utils";
import { _ } from "../extend";
import tabloid from "../components/tabloid";
import inputer from "../components/inputer";
import inputerNumber from "../components/inputer-number";
import dropdownCheckInputer from "../components/inputer-dropdown-check";

export default {
  name: "activities",
  components: {
    tabloid,
    inputer,
    inputerNumber,
    dropdownCheckInputer,
  },
  data: () => ({
    columns: {
      outpostId: { title: "Hlídka"},
      name: { title: "Název"},
      description: { title: "Popis"},
      actions: {},
    },
    selectedId: null,
  }),
  computed: {
    ...mapState(["outpost"]),
    activities() {
      let result = _.select(this.$store.state.freeTimeActivities, (item, id) => ({
        ...item,
        onRowClick: () => this.select(id),
      }))

      return result;
    },
    selectedActivity() {
      return this.$store.state.freeTimeActivities[this.selectedId];
    },
    scope_items() {
      const activityDays = this.$store.state.partilyDays.filter((i, index) => index != 0); // ignore first and last day (last day didn't come from BE)
      return activityDays.map(i => [new Date(i.setHours(0)), new Date(i.setHours(12))]).flat();
    },
    is_new() {
      return (id) => this.$store.getters.isChangedAt(['freeTimeActivities', id || this.selectedId, 'id']);
    },
  },
  methods: {
    add() {
      this.selectedId = data.newGuid();
      this.$store.commit("add", {
        paths: ["freeTimeActivities", this.selectedId],
        value: {
          outpostId: this.outpost.id,
        }
      });
    },
    remove(id) {
      this.$store.commit("remove", { paths: ['freeTimeActivities', id] })
    },
    select(id) {
      if (this.$store.state.freeTimeActivities[id] && this.$store.state.freeTimeActivities[id].outpostId != this.outpost.id)
        return;

      this.selectedId = id;
    },
  },
};
</script>
  
<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

.page_activities
  @include table-view()
  grid-template-areas: "head actions end link" "selected selected selected selected" "table table table table"
  grid-template-columns: auto auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: head
  .actions
    grid-area: actions
  .selected
    grid-area: selected
    display: grid
    margin: 0 auto
    width: 100%
    max-width: $w-content
    grid-template-columns: 1fr 2fr
    grid-gap: .5rem
    label
      grid-column: 1
      align-self: center
      text-align: right
    button
      grid-column: 1 / 3
      justify-self: center
      width: 15rem
      @include button-secondary()

  table
    grid-area: table
    th
      cursor: pointer
    tbody tr.selectable
      cursor: pointer
      transition: box-shadow 0.5s
      &:hover
        box-shadow: 2px 2px 5px #589678
      .remove
        @include button-danger()
</style>
  